import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@features/ui';
import React from 'react';
import { useAuth } from '@hooks/useAuth.ts';
import { AvatarHeader } from '@features/core/ui/layout/avatarHeader.tsx';
import { useAuthStore } from '@stores/authStore.ts';

export function RightSidebar({
  isUser,
  ...props
}: React.ComponentProps<typeof Sidebar> & { isUser?: boolean }) {
  const { logout } = useAuth();
  const { auth } = useAuthStore();

  console.log('isUser', isUser);

  return (
    <Sidebar collapsible="icon" side={'right'} variant="floating" {...props}>
      <SidebarHeader className="mb-8 pl-7 pt-12">
        <img alt="logo" height={42} src="/assets/logo.svg" width={160} />
      </SidebarHeader>
      <SidebarContent>
        <SidebarMenu>
          <SidebarMenuItem className={'border-t border-b py-2'}>
            <div className={'flex items-center gap-x-2.5'}>
              <AvatarHeader className={'w-10 h-10'} />
              <div className={'gap-1'}>
                <p className="text-sm font-bold">{auth?.user?.username}</p>
                {!isUser && <p className={'text-xs text-[#B3B3B3]'}>Admin</p>}
              </div>
            </div>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className="h-[50px] gap-x-[18px]">
              <button
                className={'cursor-pointer flex justify-between items-center'}
                onClick={logout}
              >
                <span>Notification</span>
                <p className={'text-xs'}>99+</p>
              </button>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarContent>
    </Sidebar>
  );
}
